import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../../environments/environment';

const BASE_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(private httpClient: HttpClient) { }

  public get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.httpClient.get(BASE_URL + path, { params }).pipe(catchError(this.formatErrors));
  }

  public post(path: string, body: object = {}): Observable<any> {
    return this.httpClient
      .post(BASE_URL + path, JSON.stringify(body))
      .pipe(catchError(this.formatErrors));
  }

  public postMultipartForm(path: string, body: object = {}): Observable<any> {
    return this.httpClient
      .post(BASE_URL + path, body)
      .pipe(catchError(this.formatErrors));
  }

  public postBlob(path: string, body: object = {}): Observable<Blob> {
    // const options = { responseType: 'blob' }; there is no use of this
    // this.http refers to HttpClient.
    // Note here that you cannot use the generic get<Blob> as it does not compile:
    // instead you "choose" the appropriate API in this way.
    return this.httpClient.post(BASE_URL + path, body).pipe(catchError(this.formatErrors));
  }

  public put(path: string, body: object = {}): Observable<any> {
    return this.httpClient
      .put(BASE_URL + path, JSON.stringify(body))
      .pipe(catchError(this.formatErrors));
  }

  public delete(path: string): Observable<any> {
    return this.httpClient.delete(BASE_URL + path).pipe(catchError(this.formatErrors));
  }

  public formatErrors(error: any): Observable<any> {
    return throwError(error);
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  public handleError<T>(operation = 'operation', result?: T) {
    return (error: any) => {
      // TODO: better job of transforming error for user consumption
      // Let the app keep running by returning an empty result.
      // return of(result as T);
      if (error.status === 200 || error.status === 400) {
        return result;
      }
      let message = '';
      if (!error.status || error.status === undefined || error.status === 0) {
        message = 'Your request failed to processed. Please try again';
      } else {
        message = 'Your request can not be processed due to technical fault. Inconvenience caused is highly regretted!';
      }
      return {
        status: 400,
        object: [
          {
            code: 'runtime',
            field: 'error',
            defaultMessage: message
          }
        ]
      };
    };
  }
}
